<template>
  <el-popover popper-class="form_pop el-select-dropdown">
    <div class="spe" slot="reference">
      <label>特色标签</label>
      <div class="el-select__tags">
        <span>
          <span v-if="speTags.length === 0" style="color: #ccc;font-size: 12px;">请选择</span>
          <span
            class="el-tag el-tag--info el-tag--mini"
            v-for="eachTag in speTags" :key="eachTag.code"
          >
            <span class="el-select__tags-text">
              {{eachTag.codeName}}({{eachTag.choose.map(el => el.context).join(',')}})
            </span>
            <i class="el-tag__close el-icon-close" @click.stop="delSpeItem(eachTag)"></i>
          </span>
        </span>
      </div>
    </div>
    <div class="spe_list">
      <div v-for="(spe, z) in speList" :key="z">
        <div class="spe-name">{{spe.codeName}}</div>
        <span :class="{'select': noSelect(spe.lableDetailsResponses)}" @click="chooseItem('', spe.lableDetailsResponses)">
          不限<img :src="mulIcon">
        </span>
        <span
          v-for="(el, j) in spe.list" :key="j"
          :class="{'select': curSelect(el)}"
          @click="chooseItem(el, spe.lableDetailsResponses, spe.selectType)"
        >
          {{el.context}}<img :src="mulIcon" />
        </span>
      </div>
    </div>
  </el-popover>
</template>

<script>
import mulIcon from '@/assets/multiple_select.png'
export default {
  name: 'PointSelectSpe',
  props: {
    config: {
      type: Object,
      default () { return {} }
    },
    value: Array
  },
  data () {
    return {
      mulIcon,
      speList: [],
      speTags: [],
      allList: [],
      result: []
    }
  },
  computed: {
    res: {
      get () {
        let selectType = this.config.selectType
        if (selectType && selectType == '2') return this.value && this.value.length ? this.value : []
        else return this.value && this.value[0] ? this.value[0] : ''
      },
      set (v) {
        let selectType = this.config.selectType
        let data = selectType == 2 ? v : [v]
        this.$emit('input', data)
      }
    },
    noSelect () {
      return list => {
        if (!this.result.length) return true
        let choose = 0
        list.forEach(el => {
          if (this.result.indexOf(el.code + el.value) > -1) choose = choose + 1
        })
        if (choose > 0) return false
        else return true
      }
    },
    curSelect () {
      return el => {
        if (!this.result.length) return false
        return this.result.indexOf(el.code + el.value) > -1
      }
    }
  },
  watch: {
    '$store.state.bmap.labelListMap': {
      immediate: true,
      handler (v) {
        if (v) {
          this.speList = Object.values(v).filter(el => el.type == 7)
        }
      }
    }
  },
  async created () {
    this.placeholder = this.config.placeholder || '请选择'
  },
  async mounted () {},
  methods: {
    chooseItem (el, list, selectType) { // 点击切换选中状态
      let rmListAllItem = array => {
        array.forEach(element => {
          let idx = this.result.indexOf(element.code + element.value)
          if (idx > -1) {
            // this.$set(this.result, idx, null)
            // this.result[idx] = null
            this.result.splice(idx, 1)
          }
        })
        this.$forceUpdate()
      }
      if (el) {
        let idx = this.result.indexOf(el.code + el.value)
        if (idx > -1) this.result.splice(idx, 1)
        else {
          if (selectType && selectType === '1') rmListAllItem(list)
          this.result.push(el.code + el.value)
        }
      } else { // 不限
        if (list) rmListAllItem(list)
      }
      this.speTags = this.handleSpeShow()
      this.handleSpeCthHeight()
      this.$emit('input', this.result.filter(el => el))
    },
    delSpeItem (item) {
      item.choose.forEach(el => {
        let idx = this.result.indexOf(el.code + el.value)
        if (idx > -1) this.result.splice(idx, 1)
      })
      this.speTags = this.handleSpeShow()
      this.handleSpeCthHeight()
    },
    handleSpeShow () {
      let speList = this.speList
      let speCodes = speList.map(el => el.code)
      let speChoose = this.result.filter( el => el && speCodes.some(ele => el.indexOf(el) > -1) )
      return !speChoose.length ? [] : this.getChooseContexts(speChoose, speList)
    },
    getChooseContexts (speChoose) {
      let contextsMap = this.$store.state.bmap.labelContextMap
      let data = speChoose.map(el => {
        return contextsMap[el]
      })
      let sort = [...new Set(data.map(el => el.code))]
      return sort.map(el => {
        let choose = data.filter(ele => ele.code === el)
        return {
          codeName: choose[0].codeName,
          choose
        }
      })
    },
    handleSpeCthHeight () {
      this.$nextTick(() => {
        document.querySelector('.spe').style.height = document.querySelector('.spe .el-select__tags').clientHeight + 10 + 'px'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.spe_list {
  width: 294px;
  margin-top: -20px;
  .spe-name {
    font-size: 12px;
    color: #666;
    margin: 0 5px;
    margin-top: 20px;
  }
  span {
    display: inline-block;
    position: relative;
    width: 63px;
    line-height: 30px;
    border: 1px solid #E9E9E9;
    margin: 5px;
    font-size: 12px;
    cursor: pointer;
    text-align: center;
    img {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
    }
    &.select {
      border-color: #282729;
      img {
        display: block;
      }
    }
  }
}
</style>
